module.exports = __webpack_public_path__ + "img/info.cb85f15d.png";